import styled, { css } from 'styled-components';
import { getTypographyFontSize } from "../../theme/selectors";
var Text = styled.div.withConfig({
  displayName: "Text",
  componentId: "zd23il-0"
})(["display:inline-block;", " ", " ", " ", " ", " ", " ", " ", ""], function (_ref) {
  var uppercase = _ref.uppercase;
  return uppercase && css(["text-transform:uppercase;"]);
}, function (_ref2) {
  var center = _ref2.center;
  return center && css(["text-align:center;"]);
}, function (_ref3) {
  var fontWeight = _ref3.fontWeight;
  return css(["font-weight:", ";"], fontWeight);
}, function (_ref4) {
  var color = _ref4.color;
  return css(["color:", ";"], color);
}, function (_ref5) {
  var fontFamily = _ref5.fontFamily;
  return css(["font-family:", ";"], fontFamily !== null && fontFamily !== void 0 ? fontFamily : 'inherit');
}, function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 300 : _ref6$size;
  return getTypographyFontSize(size);
}, function (_ref7) {
  var ellipsis = _ref7.ellipsis;
  return ellipsis ? "\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  " : '';
}, function (_ref8) {
  var nowrap = _ref8.nowrap;
  return nowrap && css(["white-space:nowrap;"]);
});
export default Text;